import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { CropSettingsState, StateCropSetting } from '../../cropsetting.model';
import * as CropSettingActions from '../actions/cropsetting.actions';

export const adapter: EntityAdapter<StateCropSetting> = createEntityAdapter<StateCropSetting>();
export const initialState: CropSettingsState = adapter.getInitialState({});

export const cropSettingsReducer = createReducer<CropSettingsState>(
  initialState,
  on(CropSettingActions.loadCropSettingsSuccess, (state, { cropSettings }) => {
    const cropSettingsWithIds = cropSettings.map((cropSetting) => ({
      ...cropSetting,
      id: cropSetting.id,
    }));
    return adapter.setAll(cropSettingsWithIds, state);
  }),
);
